import type { StackProps } from "@chakra-ui/react";
import { Box, Text } from "@chakra-ui/react";
import React from "react";

interface Props extends StackProps {
  label: string;
  value: string | number;
  spaced?: boolean;
}

export const OrderCardSummaryItem = ({
  label,
  value,
  spaced,
  ...props
}: Props) => {
  return (
    <Box
      {...props}
      display={spaced ? "flex" : undefined}
      justifyContent={spaced ? "space-between" : undefined}
      gap="0.5"
    >
      <Text
        display="inline-block"
        whiteSpace="nowrap"
      >
        {label}
      </Text>{" "}
      <Text display="inline-block">{value}</Text>
    </Box>
  );
};
